import ReactDOM from 'react-dom';
import React from 'react';

import App from './app';

const rootElement = document.querySelector('#app');
if (rootElement) ReactDOM.render(<App />, rootElement);
